import { Label, Listbox } from "@headlessui/react";
import { FC, Fragment } from "react";
import { ButtonSelectAvatar } from "../molecules/ButtonSelectAvatar";
import { ListSelectAvatar } from "../molecules/ListSelectAvatar";

export type optionAvatar = {
  id: number;
  name: string;
  avatar: string;
};
export type SelectAvatarProps = {
  selected: optionAvatar | undefined;
  options: optionAvatar[];
  setSelected: (option: optionAvatar) => void;
  tittle: string;
  text_describe?: string;
  span?: string;
  name?: string;
  className?: string;
};

export const SelectAvatar: FC<SelectAvatarProps> = ({
  options,
  selected,
  setSelected,
  tittle,
  text_describe,
  span,
  name,
  className,
}) => {

  return (
    <div className={className}>
      <Listbox value={selected} onChange={setSelected} name={name}>
        <div>
          <div className="flex justify-between">
            <Label className="block text-sm font-medium leading-6 text-gray-900">
              {tittle}
            </Label>
            <span className={`text-sm leading-6 text-gray-500`}>{span}</span>
          </div>

          <div className="relative">
            <ButtonSelectAvatar selected={selected} />
            <ListSelectAvatar option={options} />
          </div>
          <p className="mt-1 text-sm text-gray-400">{text_describe}</p>
        </div>
      </Listbox>
    </div>
  );
};
